import React, { useState, useEffect, useContext, useCallback } from 'react';
import { useFetch, Context } from 'store';

import { Button, Icon, notification } from 'antd';

import { AsyncTable } from '_src/components';
import { PersistentRepo } from '_src/shared/repo';
import { Restricted } from '_src/shared/restrict';
import { objToSnakeCase, debounce } from '_src/utils';
import services from '_src/services';
import { Select, Input } from '_src/shared/form-helpers';
import { PageWrapper, ActionRow } from '_src/shared/styles';
import { camelToSnakeCase } from '../../utils/helpers';
import { noteType, programTypeOptions } from './constants';

import qs from 'qs';

import { PageTitle, Search } from './styles';

export default () => {
  const baseApi = GLOBALS.BASE_API;
  const resource = 'userActivityLogs';
  const token = PersistentRepo.get('token');

  const config = services[resource];
  const locationsConfig = services['studentRecords'];

  const { getData } = useContext(Context);

  const getInitialLocation = () => {
    const allBranchesSelected = PersistentRepo.get('allBranches');

    const location = allBranchesSelected ? allBranchesSelected : PersistentRepo.get('location');
    const user = getData('user');
    const branchId = user.branchId || 1;

    return location ? location : `allxallx${branchId}`;
  };

  const getInitialId = type => {
    const [locationType, locationId, branchId] = getInitialLocation().split('x');
    return type === 'locationType' ? locationType : branchId;
  };

  const [locations, setLocations] = useState([]);
  const [location, setLocation] = useState(getInitialLocation());
  const [loading, setLoading] = useState(true);
  const [locType, setLocType] = useState(0);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [skip, setSkip] = useState(0);
  const [studentName, setStudentName] = useState('');
  const [instructorName, setInstructorName] = useState('');
  const [type, setType] = useState('all');
  const [programType, setProgramType] = useState('all');

  const { get: getLocations, busy } = useFetch({ ...locationsConfig.getLocations });

  useEffect(() => {
    getLocations().then(data => {
      setLocations([{ id: `all`, label: `All Branches` }, ...data]);
      setLoading(false);
    });
  }, []);
  const tableData = getData('userActivityLogs');
  const totalCount = tableData?.total;

  const [filterParams, setFilterParams] = useState({
    limit: 20,
    skip,
    branchId: getInitialId('branchId'),
    locationType: locType
      ? locType
      : getInitialId('locationType') === 'all'
      ? 0
      : getInitialId('locationType') === 'yard'
      ? 1
      : 2
  });

  const downloadReport = async () => {
    const queryParams = qs.stringify(
      objToSnakeCase({ ...filterParams, skip: 0, limit: totalCount }),
      {
        arrayFormat: 'comma'
      }
    );
    setDownloadLoading(true);

    const response = await fetch(`${baseApi}/reports/clockin_reports?${queryParams}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    setDownloadLoading(false);
    const blob = await response.blob();
    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = 'clockin_report.xlsx';
    document.body.appendChild(a);
    a.click();
    a.remove();

    URL.revokeObjectURL(url);
  };

  const debounceCallback = useCallback(
    debounce(
      params => {
        setFilterParams(params);
      },
      1000,
      false
    ),
    []
  );

  const handleTableSort = (_, __, sort) => {
    if (!sort.columnKey) {
      return;
    }

    setFilterParams({
      ...filterParams,
      orderBy: camelToSnakeCase(sort.columnKey),
      order: sort.order === 'ascend' ? 'asc' : 'desc'
    });
  };

  const handleCustomTable = () => {
    if (type === 'all') {
      return config.table;
    }
    if (type === 'test_deleted') {
      return config.table
        .filter(
          ({ key }) =>
            key !== 'attendanceArchivedDate' &&
            key !== 'testArchivedDate' &&
            key !== 'attendanceDeletedDate'
        )
        .map(item => {
          return { ...item, title: item.key === 'deleter' ? 'Deleter' : item.title };
        });
    }

    if (type === 'test_archived') {
      return config.table
        .filter(
          ({ key }) =>
            key !== 'attendanceArchivedDate' &&
            key !== 'testDeletedDate' &&
            key !== 'attendanceDeletedDate'
        )
        .map(item => {
          return { ...item, title: item.key === 'deleter' ? 'Archiver' : item.title };
        });
    }

    if (type === 'attendance_deleted') {
      return config.table
        .filter(
          ({ key }) =>
            key !== 'attendanceArchivedDate' &&
            key !== 'testArchivedDate' &&
            key !== 'testDeletedDate' &&
            key !== 'testType'
        )
        .map(item => {
          return { ...item, title: item.key === 'deleter' ? 'Deleter' : item.title };
        });
    }

    if (type === 'attendance_archived') {
      return config.table
        .filter(
          ({ key }) =>
            key !== 'attendanceDeletedDate' &&
            key !== 'testArchivedDate' &&
            key !== 'testDeletedDate' &&
            key !== 'testType'
        )
        .map(item => {
          return { ...item, title: item.key === 'deleter' ? 'Archiver' : item.title };
        });
    }
  };

  const customTableConfig = handleCustomTable() || [];

  return (
    <PageWrapper>
      <PageTitle>Archived & Deleted Sessions/Tests</PageTitle>

      <Search>
        <Select
          label="Branches"
          showSearch
          onChange={locationSelected => {
            setLocation(locationSelected);
            setInstructorName('');
            setStudentName('');

            const { studentName, instructor, ...restParams } = filterParams;
            if (locationSelected === 'all') {
              setFilterParams({ limit: filterParams.limit, skip: filterParams.skip });
              PersistentRepo.set('allBranches', locationSelected);
            } else {
              const [locationType, locationId, branchId] = locationSelected.split('x');
              setFilterParams(() => {
                return {
                  ...restParams,
                  branchId: locationSelected ? branchId : getInitialId('branchId'),
                  locationType: locationSelected
                    ? locationType === 'all'
                      ? 0
                      : locationType === 'yard'
                      ? 1
                      : 2
                    : getInitialId('locationType')
                };
              });
              PersistentRepo.set('location', locationSelected);
              PersistentRepo.delete('allBranches');
            }
          }}
          options={locations}
          value={location}
        />

        <Input
          label="Student Name"
          onChange={e => {
            if (e.length === 0) {
              setStudentName('');
              const { studentName, ...restParams } = filterParams;
              debounceCallback(restParams);
              return;
            }

            const [first, last = ''] = e.split(' ');
            setStudentName(e);
            debounceCallback({ ...filterParams, studentName: `${first} ${last}` });
          }}
          value={studentName}
          allowClear
        />

        <Input
          label="Instructor Name"
          onChange={e => {
            if (e.length === 0) {
              setInstructorName('');
              const { instructor, ...restParams } = filterParams;
              debounceCallback(restParams);
              return;
            }

            const [first, last = ''] = e.split(' ');
            setInstructorName(e);
            debounceCallback({ ...filterParams, instructor: `${first} ${last}` });
          }}
          value={instructorName}
          allowClear
        />

        <Select
          label="Type"
          onChange={val => {
            setType(val);
            if (val === 'all') {
              const { note, ...rest } = filterParams;
              debounceCallback(rest);

              return;
            }

            debounceCallback({ ...filterParams, note: val });
          }}
          options={noteType}
          value={type}
        />

        <Select
          label="Program Type"
          onChange={val => {
            setProgramType(val);
            if (val === 'all') {
              const { programType, ...rest } = filterParams;
              debounceCallback(rest);

              return;
            }

            debounceCallback({ ...filterParams, programType: val });
          }}
          options={programTypeOptions}
          value={programType}
        />
      </Search>
      <Restricted resource={'download_clockin_reports'} method="GET">
        <ActionRow style={{ justifyContent: 'flex-start', marginBottom: '10px' }}>
          <Button type="default" onClick={() => downloadReport()} loading={downloadLoading}>
            <Icon type="download" /> Download report
          </Button>
        </ActionRow>
      </Restricted>

      <div style={{ overflowX: 'auto' }}>
        <AsyncTable
          resource={resource}
          pagination
          config={{
            ...config,
            table: [
              ...customTableConfig,
              {
                title: 'Location',
                key: 'locationType',
                sorter: location === 'all' ? false : true,
                render: (_, { branchId, locationType }) => {
                  const a = locations.find(
                    loc => branchId === loc.branchId && locationType === loc.type
                  );

                  return a?.label ?? 'N/A';
                }
              }
            ]
          }}
          onChange={handleTableSort}
          params={filterParams}
          fileName={resource}
          onChangePage={setSkip}
        />
      </div>
    </PageWrapper>
  );
};
